import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "./axiosBaseQuery";

const baseUrl =
  process.env.REACT_APP_API_BASE_URL || "https://localhost:7123/api/v1";

export const api = createApi({
  reducerPath: "api",
  baseQuery: axiosBaseQuery({ baseUrl }),
  tagTypes: [
    "Dashboard",
    "AdminCatalog",
    "Roles",
    "Designations",
    "Users",
    "Employees",
    "HrDepartments",
    "HrDesignations",
    "HrHolidays",
    "HrDeductions",
    "HrTax",
    "MasterCustomers",
    "MasterCustomerLinks",
    "MasterCustomerBranchMap",
    "MasterProducts",
    "MasterProductLinks",
    "MasterProductGroups",
    "MasterProductBranchMap",
    "MasterEmployees",
    "Feedback",
    "Settings",
    "Vehicles",
    "VehicleRequests",
    "StockLpo",
    "StockLpoRevisions",
    "StockIn",
    "StockOut",
    "StockReturn",
    "StockAdjustment",
    "StockBalance",
  ],
  endpoints: () => ({}),
});
